import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { matrix } from '../endpoints';

import { MatrixWrapper } from './wrapper';
import { MatrixKnobs } from './knobs';
import { filterProperties } from 'utilities/srsUtils';

const flags = [SrsPropertyFlag.Categorical];

export const config = {
	key: 'MATRIX',
	label: 'Matrix',
	icon: 'heatmap',
	wrapper: MatrixWrapper,
	endpoint: matrix,
	Knobs: MatrixKnobs,
	flags: flags,
	createDefaultOptions: filteredProperties => {
		return {
			options: {
				propertyList: [filteredProperties[0].name, filteredProperties[1].name],
				parameters: {
					"maxRows": 20,
				    "maxColumns": 10,
				    "sortColumns": "Ordinal",
				    "sortRows": "Ordinal"
				},
			},
		};
	},
	createDefaultConfiguration: _filteredProperties => {
		return {
			
		};
	},
	isValid: selectedDefinitionName => {
		return filterProperties(selectedDefinitionName, flags).length >= 2;
	},
};
